<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Accounts" title="Courier Management" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-6 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="fetchCourier()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="courier_status" @change="fetchCourier()">
											<option value="">Courier Status</option>
                                            <option value="1">Pending</option>
                                            <option value="2">Completed</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="payment_status" @change="fetchCourier()">
											<option value="">Payment Status</option>
                                            <option value="1">Received</option>
                                            <option value="2">Not Received</option>
                                            <option value="3">Partially Received</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @keyup="fetchCourier()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Dealer / Technician</th>
											<th>Total No.of Devices</th>
											<th>No.of New Devices</th>
											<th>No.of Repair Devices</th>
											<th>Transaction Amount</th>
											<th>Date</th>
											<th>Invoice</th>
                                            <th>Courier Status</th>
											<th>Payment Status</th>
											<th>Added By</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(couriers.length)">
										<tr align="center" v-for="(courier,index) in couriers" :key="courier.id">
                                            <td>{{index+1}}</td>
											<td class="text-start">
												<template v-if="courier.dealer_id != null && courier.dealer_id !== ''">
													<div><strong>Dealer</strong></div>
													<div>{{ courier.dealer_name || "—" }}</div>
													<div class="text-muted">{{ courier.dealer_contact || "—" }}</div>
												</template>
												<template v-else-if="courier.technician_id != null && courier.technician_id !== ''">
													<div><strong>Technician</strong></div>
													<div>{{ courier.technician_name || "—" }}</div>
													<div class="text-muted">{{ courier.technician_contact || "—" }}</div>
												</template>
												<span v-else>—</span>
											</td>
											<td>{{courier.total_devices}}</td>
											<td>
												<template v-if="courier.no_of_new_gps > 0 || courier.no_of_new_cameras > 0 || courier.no_of_new_speed_governors > 0">
													<span v-if="courier.no_of_new_gps > 0">GPS: <b>{{courier.no_of_new_gps}}</b></span><br>
													<span v-if="courier.no_of_new_cameras > 0">Camera: <b>{{courier.no_of_new_cameras}}</b></span><br>
													<span v-if="courier.no_of_new_speed_governors > 0">Speed Governor: <b>{{courier.no_of_new_speed_governors}}</b></span><br>
												</template>
												<span v-else>0</span>
											</td>
											<td>
												<template v-if="courier.no_of_service_gps > 0 || courier.no_of_service_cameras > 0 || courier.no_of_service_speed_governors > 0">
													<span v-if="courier.no_of_service_gps > 0">GPS: <b>{{courier.no_of_service_gps}}</b></span><br>
													<span v-if="courier.no_of_service_cameras > 0">Camera: <b>{{courier.no_of_service_cameras}}</b></span><br>
													<span v-if="courier.no_of_service_speed_governors > 0">Speed Governor: <b>{{courier.no_of_service_speed_governors}}</b></span><br>
												</template>
												<span v-else>0</span>
											</td>
											<td>
												Total Amount (₹): {{courier.total_amount}}<br>
												Paid Amount (₹): {{courier.paid_amount}}<br>
											</td>
											<td>{{$filters.formatDate(courier.created_at)}}</td>
											<td>
												<div>{{ courier.invoice_number || "—" }}</div>
												<a
													v-if="courier.invoice"
													:href="getInvoiceUrl(courier.invoice)"
													target="_blank"
													rel="noopener noreferrer"
													class="btn btn-sm btn-outline-primary mt-1"
												>
													Download
												</a>
											</td>
											<td>
												<span class="badge rounded-pill bg-info text-dark" v-if="courier.courier_status == 1">Pending</span>
												<span class="badge rounded-pill bg-success" v-else-if="courier.courier_status == 2">Completed</span>
											</td>
											<td>
												<span class="badge rounded-pill bg-success" v-if="courier.payment_status == 1">Received</span>
												<span class="badge rounded-pill bg-danger" v-else-if="courier.payment_status == 2">Not Received</span>
												<span class="badge rounded-pill bg-warning" v-else-if="courier.payment_status == 3">Partially Received</span>
											</td>
											<td>{{courier.added_user_name}}<br><br>
												<span class="text-muted" v-if="courier.created_from == 1">From: Device Management</span>
												<span class="text-muted" v-else-if="courier.created_from == 2">From: Courier Management</span>
											</td>
                                            <td>
												<button class="btn btn-warning btn-sm" @click="updateInvoice(courier)">Update Invoice</button>
												<button
													v-if="courier.courier_status == 2 && (courier.payment_status == 1)"
													type="button"
													class="btn btn-primary btn-sm mt-1"
													@click="verifyPayment(courier)"
												>
													Verify payment
												</button>
												<button
													v-if="courier.payment_status == 2 || courier.payment_status == 3"
													type="button"
													class="btn btn-success btn-sm mt-1"
													@click="courierRepayment(courier)"
												>
													Repayment
												</button>
												<button
													v-if="courier.payment_status == 1"
													type="button"
													class="btn btn-info btn-sm mt-1"
													@click="viewCourierDetails(courier)"
												>
													View details
												</button>
                                            </td>
                                        </tr>
                                      
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available</td>
										</tr>

									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(couriers.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchCourier(page.url + '&limit=' + listing_length + '&courier_status=' + courier_status + '&payment_status=' + payment_status + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="saveInvoice" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Invoice Number<span class="text-danger">*</span></label>
                        	<input class="form-control" type="text" placeholder="" v-model="invoice_no"/>
                            <div v-if="errors.invoice_no" class="text-danger">{{ errors.invoice_no }}</div>
                        </div>

						<div class="col-md-12 form-group mt-2">
                            <label class="control-label">Upload Invoice<span class="text-danger">*</span></label>
                        	<input class="form-control" type="file" @change="handleFileUpload" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"/>
                            <div v-if="errors.invoice_file" class="text-danger">{{ errors.invoice_file }}</div>
                        </div>
                    </div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="loading">
							<span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
							{{ loading ? "Saving..." : button_title }}
						</button>
						<button class="btn btn-light" type="button" @click="closeModal()" :disabled="loading">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>


	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Pincode Page",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {
			return {
				
				modal_title: "Update Invoice",
				button_title: "Save",

				keyword: "",
				showsearch: false,
				listing_length: 10,
				courier_status:"",
				payment_status:"",
				token: "",
				errors: {},

                button_title: "Save",
                name: "",
				technician: "",
				invoice_no: "",
				invoice_file: null,
				selected_courier_id: null,
				loading: false,

				couriers:[],
				
			};
		},
		created() {
			this.fetchCourier();
		},
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			fetchCourier(page_url = null) {
				this.getToken();
				let url = "/staffs/couriers?limit=" + this.listing_length +  "&courier_status=" + this.courier_status +  "&payment_status=" + this.payment_status + "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.couriers = responseData.couriers.data;
						this.pagination = responseData.couriers.links;
						this.from = responseData.couriers.from;
						this.to = responseData.couriers.to;
						this.total = responseData.couriers.total;
						
					})
					.catch((err) => console.log(err));
			},
			

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

            updateInvoice(courier) {
                this.errors = {};
                this.invoice_no = courier.invoice_number;
                this.invoice_file = null;
                this.selected_courier_id = courier.id;
                this.loading = false;
				this.modal_title = "Update Invoice";
				this.button_title = "Save";
				this.showModal();
            },

            verifyPayment(courier) {
                this.$router.push({ name: "verify_courier", params: { courier_id: courier.id } });
            },

            courierRepayment(courier) {
                this.$router.push({ name: "courier_repayment", params: { courier_id: courier.id } });
            },

            viewCourierDetails(courier) {
                this.$router.push({ name: "courier_details", params: { courier_id: courier.id } });
            },

            getInvoiceUrl(path) {
                if (!path) return "";
                if (String(path).startsWith("http://") || String(path).startsWith("https://")) {
                    return path;
                }
                return this.$image_url + path;
            },

            handleFileUpload(event) {
                this.invoice_file = event.target.files[0];
                // Clear any previous file errors
                if (this.errors.invoice_file) {
                    delete this.errors.invoice_file;
                }
            },

            validateForm() {
                this.errors = {};
                let isValid = true;

                if (!this.invoice_no || this.invoice_no.trim() === '') {
                    this.errors.invoice_no = 'Invoice number is required';
                    isValid = false;
                }

                if (!this.invoice_file) {
                    this.errors.invoice_file = 'Invoice file is required';
                    isValid = false;
                } else {
                    // Validate file type
                    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
                    if (!allowedTypes.includes(this.invoice_file.type)) {
                        this.errors.invoice_file = 'Please upload a valid file (PDF, JPG, PNG, DOC, DOCX)';
                        isValid = false;
                    }
                    
                    // Validate file size (5MB limit)
                    if (this.invoice_file.size > 5 * 1024 * 1024) {
                        this.errors.invoice_file = 'File size must be less than 5MB';
                        isValid = false;
                    }
                }

                return isValid;
            },

            saveInvoice() {
                if (this.loading) return;
                if (!this.validateForm()) {
                    return;
                }

                this.loading = true;
                this.getToken();
                
                const formData = new FormData();
                formData.append('invoice_number', this.invoice_no);
                formData.append('invoice', this.invoice_file);
                formData.append('courier_id', this.selected_courier_id);

                this.$axios
                    .post('/staffs/updateInvoice', formData, {
                        headers: {
                            'Authorization': 'Bearer ' + this.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        if (response.status === 200) {
                            this.$swal('Success', 'Invoice updated successfully', 'success');
                            this.closeModal();
                            this.fetchCourier(); // Refresh the list
                        }
                    })
                    .catch((error) => {
                        console.error('Error updating invoice:', error);
                        if (error.response && error.response.data && error.response.data.message) {
                            this.$swal('Error', error.response.data.message, 'error');
                        } else {
                            this.$swal('Error', 'Failed to update invoice. Please try again.', 'error');
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
			
		},
	};
</script>